namespace OfficeGuy.Inputs {
    export class LongText {
        static Init(): void {
            $(document)
                .on("input.autoexpand", "textarea, .og-richtexteditor", function () {
                    var $Textarea = $(this);
                    var Value = $Textarea[0].tagName == "DIV" ? $Textarea.text() : <string>$Textarea.val();
                    $Textarea.toggleClass("textarea-grow", Value.length != 0 || $Textarea.find("img").length > 0);
                })
                .on("focus.og-textarea", "textarea", function () {
                    var $Textarea = $(this);
                    $Textarea.closest(".textarea-container").addClass("textarea-container-focus");
                })
                .on("focusout.og-textarea", "textarea", function () {
                    var $Textarea = $(this);
                    $Textarea.closest(".textarea-container").removeClass("textarea-container-focus");
                });
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.Inputs.LongText.Init();
});